import React from "react";
import FontIcon from "react-md/lib/FontIcons";
import Link from "gatsby-link";

function GetNavList(config) {
  const Episodes = [
    {
      primaryText: "La masacre que no pudieron borrar",
      secondaryText: "Capítulo 1",
      leftIcon: null,
      component: Link,
      to: "/la-masacre-que-no-pudieron-borrar.html"
    },
    {
      primaryText: "Militares al banquillo",
      secondaryText: "Capítulo 2",
      leftIcon: null,
      component: Link,
      to: "/militares-al-banquillo.html"
    },
    {
      primaryText: "Hubo días de horror",
      secondaryText: "Capítulo 3",
      leftIcon: null,
      component: Link,
      to: "/hubo-dias-de-horror.html"
    },
    {
      primaryText: "Recuperar a los seres queridos, uno por uno",
      secondaryText: "Capítulo 4",
      leftIcon: null,
      component: Link,
      to: "/recuperar-a-los-seres-queridos-uno-por-uno.html"
    },
  ]
  const NavList = [
    {
      primaryText: "Inicio",
      leftIcon: null,
      component: Link,
      to: "/"
    },
    {
      primaryText: "Capítulos",
      leftIcon: null,
      nestedItems: Episodes
      //component: Link,
      //to: "/la-masacre-que-no-pudieron-borrar.html"
    },
    {
      primaryText: "Acerca",
      leftIcon: null,
      component: Link,
      to: "/acerca/"
    },
    {
      primaryText: "Créditos",
      leftIcon: null,
      component: Link,
      to: "/creditos/"
    },
  ];

  NavList.push();
  return NavList;
}
export default GetNavList;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavList.js